import { defineStore } from 'pinia'
import EventService from '@/services/APIService.js'

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const profileStore = defineStore('profileStore', {
    state: () => {
        return {
            // all these properties will have their type inferred automatically

            state: 'initializing',
            user_id: null,
            base_data: false,

            permissions: false,
            permissions_loading: false
        }
    },

    getters: {

    },
    actions: {


        init(user_id){


            let self = this;

            self.$reset();
            self.user_id = user_id;

            EventService.post('/api/v3/user/' + self.user_id, {
                expand: ['roles', 'sessions', 'ip_whitelist', 'two_factor_methods', 'dates']
            }).then((response) => {


                self.state = 'ready';
                self.base_data = response.data.payload;


            });


        },

        loadPermissions() {

            let self = this;
            self.permissions_loading = true;


            EventService.post('/api/v3/user/' + self.user_id, {
                expand: ['shop_permissions']
            }).then((response) => {

                self.applyPermissions(response.data.payload);
                self.permissions_loading = false;

            });


        },

        // Adopts the shop_permissions of any v3 user response, so a PATCH that was sent with
        // expand: ['shop_permissions'] refreshes the table without a second round-trip.
        applyPermissions(payload) {

            if (!payload || payload.shop_permissions === undefined) { return; }

            this.permissions = payload.shop_permissions;

        }

    }
})
